

import React, { useState, useEffect } from 'react';
import { leadCardTabOptions } from '../../../utilities/leadFunctions';


function RightQueueHeader({recording,selected, handleSelectTab, setQualifier}) {

    const items = (recording && recording > 0) ? ['Script', 'Text', 'Email', 'Notes', `Recordings (${recording})`, 'Quote'] : ['Script', 'Text', 'Email', 'Notes', 'Quote']

    const handleClick = (item) => {
        const option = getIndexOption(item)
        handleSelectTab(option)
    }

    const getIndexOption = (item) => {
        const key = item.startsWith('Recordings (') ? 'RECORDING' : item.toUpperCase()
        return leadCardTabOptions[key]
    }

    return (
        <div className="rightHeaderWrapper">
            {items.map((item, index) => (
                <div
                    className={`queueHeaderBlock ${item.split(' ')[0] === 'Recordings' && selected===leadCardTabOptions.RECORDING ? 'quilityActiveTab' : selected === getIndexOption(item) ? 'quilityActiveTab' : ''}`}
                    onClick={() => handleClick(item)}
                    key={`rightHeaderInfo${index}`}
                >
                    {item}
                </div>
            ))}
        </div>
    );

}

export default RightQueueHeader;